"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var print_button_html_1 = __importDefault(require("./print-button.html"));
(function (module) {
    'use strict';
    function PrintButtonController($routeParams, activeReport, publicExportPasscodeModal, downloadHelper, keylog, FILE_TYPES, metricsService) {
        var $ctrl = this;
        // Override Ctrl+P/Cmd+P
        keylog.registerAction([keylog.CTRL, keylog.P], function () {
            $ctrl.printReports();
        });
        angular.extend($ctrl, {
            printReports: function () {
                if ($routeParams.publicHash && activeReport.getMetadata('passcodeProtected')) {
                    publicExportPasscodeModal.show();
                }
                else {
                    metricsService.exportComplete(FILE_TYPES.PDF, metricsService.EXPORT_CALL_SOURCE.BUTTON);
                    downloadHelper.downloadPDF();
                }
            }
        });
    }
    PrintButtonController.$inject = [
        '$routeParams',
        'prActiveReport',
        'prPublicExportPasscodeModal',
        'prDownloadHelper',
        'prKeylogService',
        'pr.EXPORT_FILE_TYPES',
        'prMetricsService'
    ];
    module.directive('prExportButton', [
        'prOverrideTrigger',
        'pr.OVERRIDE_EVENTS',
        function (triggerOverrides, OVERRIDE_EVENTS) {
            return triggerOverrides({
                event: OVERRIDE_EVENTS.EXPORT_BUTTON,
                sync: true,
                data: {
                    templateUrl: print_button_html_1.default,
                    require: {
                        '$tbCtrl': '^^?prToolbar'
                    },
                    controller: PrintButtonController,
                    controllerAs: '$ctrl',
                    bindToController: true,
                    scope: {}
                }
            });
        }
    ]);
})(angular.module('qualtrics.pr'));
